import React from 'react';

import { useParams } from 'react-router-dom';

import { ReportsDashboard } from './ReportsDashboard';

export const ReportsDashboardStandalone: React.FC = () => {
  const { accountId } = useParams();

  if (!accountId) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">No se proporcionó un ID de cuenta</p>
      </div>
    );
  }

  return (
    <div className="w-full h-screen overflow-auto">
      <ReportsDashboard accountId={Number(accountId)} isStandalone />
    </div>
  );
};
